export default class cLog {
    constructor(options) {
        this.cache(options)
    }
                
    cache(options) {
        this.settings = {
            ...this.defaults,
            ...options
        }
    }
                
    get defaults() {
        return {
            name: '',
            success: 'background: #0f0; color: #000; font-weight: 900; padding:5px',
            error: 'background: #f00; color: #000; font-weight: 900; padding:5px',
            info: 'background: cyan; color: #000; font-weight: 900; padding:5px'
        }
    }
    
                
    // objects принимается через rest: раньше параметр был один, и все аргументы
    // после второго молча терялись — часть отладочных данных не доходила до консоли
    log(msg, ...objects) {
        const color = this.settings.info
        const message = `%c${this.settings.name}: ${msg}`;
        console.log(message, color, ...objects);
    }

    // именно console.error, а не console.log: иначе ошибки телефонии не попадают
    // в фильтр "Errors" консоли браузера и их невозможно быстро найти в логе
    error(msg, ...objects) {
        const color = this.settings.error
        const message = `%c${this.settings.name}: ${msg}`;
        console.error(message, color, ...objects);
    }

    success(msg, ...objects) {
        const color = this.settings.success
        const message = `%c${this.settings.name}: ${msg}`;
        console.log(message, color, ...objects);
    }

    
}